<template>
    <div class="add-task-dialog" :key="menuKey">
        <div class="add-task-title">
            <h3>添加任务</h3>
        </div>
        <!-- <el-divider></el-divider> -->
        <el-form ref="form" label-width="150px" class="add-task-form" size="small" id="myform">
            <el-divider v-if="JSON.stringify(strategyParam.taskBaseParams) !== '{}'"><strong>任务基本参数</strong></el-divider>
            <el-form-item label="策略">
                <el-select v-model="addTaskData.strategySelect" @change="strategyChange" placeholder="请先选择策略">
                    <el-option v-for="(strategy, index) in strategyList" :key="index" :label="strategy['name']" :value="strategy.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="任务名称">
                <input class="task-name-add" v-model="addTaskData.taskName" placeholder="请填写任务名称"/>
                <span class="task-error-msg" v-if="typeof this.addTaskData.taskName == 'undefined'">请填写任务名称</span>
            </el-form-item>
            <el-form-item v-for="(item, index) in taskBaseParamJudge(strategyParam.taskBaseParams)" :key="index" :label="paramJugde(index)">
                <el-select v-if="index == 'a_bourse'" v-model="addTaskData.a_bourse" @change="bourseChange('a')" :placeholder="item">
                    <el-option v-for="(bourse, index) in bourseList.bourse" :key="index" :label="bourse" :value="index"></el-option>
                </el-select>
                <el-select v-else-if="index == 'a_transaction_type'" v-model="addTaskData.a_transaction_type" @change="aTransTypeChange(index)" :placeholder="item">
                    <el-option v-for="(type, index) in abourseType" :key="index" :label="addBourseStr(type)" :value="addBourseValue(type, index)"></el-option>
                </el-select>
                <el-select v-else-if="index == 'b_bourse'" v-model="addTaskData.b_bourse" @change="bourseChange('b')" :placeholder="item">
                    <el-option v-for="(bourse, index) in bourseList.bourse" :key="index" :label="bourse" :value="index"></el-option>
                </el-select>
                <el-select v-else-if="index == 'b_transaction_type'" v-model="addTaskData.b_transaction_type" @change="aTransTypeChange(index)" :placeholder="item">
                    <el-option v-for="(type, index) in bbourseType" :key="index" :label="addBourseStr(type)" :value="addBourseValue(type, index)"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item :label="'币种'" v-if="strategyParam.taskBaseParams">
                <el-select  v-model="addTaskData.currency_type" :placeholder="strategyParam.taskBaseParams['currency_type']"> 
                    <el-option v-for="(currencyItem, index) in currencyList" :key="index" :label="currencyItem" :value="index"></el-option>
                </el-select>
            </el-form-item>

            <span class="task-error-msg" v-show="ErrorVisible">参数没填写完全!</span>
            <el-divider v-if="JSON.stringify(strategyParam.debitCreditParams) !== '{}'"><strong>交易和借贷参数</strong></el-divider>
            <el-form-item v-for="(selfParam, index) in strategyParam.debitCreditParams" :key="index" :label="debitCreditName(index)">
                <el-switch v-if="index == 'is_borrow'" v-model="addTaskData[index]"></el-switch>
                <div v-else-if="index == 'fund_occupy'">
                    <select class="assets-select" v-model="radio">
                        <option :value="1">百分比</option>
                        <option :value="0">金额</option>
                    </select>
                    <el-input v-model="addTaskData[index]" :placeholder="selfParam"></el-input>
                </div>
                <el-input v-else v-model="addTaskData[index]" :placeholder="selfParam"></el-input>
            </el-form-item>
            <el-divider v-if="JSON.stringify(strategyParam.strategyParams) !== '{}'"><strong>策略参数</strong></el-divider>
            
            <div v-if="showFlag">
                <el-form-item v-for="(selfParam, index) in handleStrategyParam.other" :key="index" :label="index">
                    <el-input v-model="addTaskData[index]" :placeholder="selfParam"></el-input>
                </el-form-item>
                <div class="strategy-param">
                    <div>
                        <span>本周</span>
                        <el-form-item v-for="(selfParam, index) in handleStrategyParam.mDlt" :key="index" :label="index">
                            <el-input v-model="newStrategyParam['CW'][index]" :placeholder="selfParam"></el-input>
                        </el-form-item>
                    </div>
                    <div>
                        <span>次周</span>
                        <el-form-item v-for="(selfParam, index) in handleStrategyParam.mDlt" :key="index" :label="index">
                            <el-input v-model="newStrategyParam['NW'][index]" :placeholder="selfParam"></el-input>
                        </el-form-item>
                    </div>
                    <div>
                        <span>季度</span>
                        <el-form-item v-for="(selfParam, index) in handleStrategyParam.mDlt" :key="index" :label="index">
                            <el-input v-model="newStrategyParam['CQ'][index]" :placeholder="selfParam"></el-input>
                        </el-form-item>
                    </div>
                    <div>
                        <span>次季</span>
                        <el-form-item v-for="(selfParam, index) in handleStrategyParam.mDlt" :key="index" :label="index">
                            <el-input v-model="newStrategyParam['NQ'][index]" :placeholder="selfParam"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>

            <div v-if="!showFlag">
                <el-form-item v-for="(selfParam, index) in strategyParam.strategyParams" :key="index" :label="index">
                    <el-input v-model="addTaskData[index]" :placeholder="selfParam"></el-input>
                </el-form-item>
            </div>
        </el-form>
        <el-divider></el-divider>
        <div class="add-task-footer1">
            <el-button @click="submitParam">确认</el-button>
            <el-button @click="dialogVisible.visible = false">取消</el-button>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions } from 'vuex'
import { post, get } from '@/api/index'
import { deepClone } from '@/utils/common'

export default {
    data() {
        return{
            addTaskVisible: true,
            menuKey: 1,
            addTaskData: {},
            strategyParam: {},
            ErrorVisible: false,
            radio: '1',
            okexBourseTransaction1: {'本周': 2, "次周": 3, '季度': 4, '次季': 10},
            huobiBourseTransaction1: {'本周': 7, "次周": 8, '季度': 9},
            transactionTypeList: [2, 3, 4, 7, 8, 9, 10],
            newStrategyParam: {'CQ': {}, 'NW': {}, 'CW': {}, 'NQ': {}},
            showFlag: false
        }
    },
    watch: {
        menuKey: function() {
            console.log('监听调用');
            ++this.menuKey;
        },
        addTaskData: function () {
            if (this.addTaskData.b_transaction_type && this.addTaskData.a_transaction_type) {
                if (this.addTaskData.b_transaction_type.length > 3 || this.addTaskData.a_transaction_type.length > 3) {
                    this.showFlag = true;
                    this.$nextTick(() => {
                        this.showFlag = true
                    })
                }
            }
        } 
    },
    created() {
        this.getBourseList();
        
        // 获取策略列表
        this.getStrategyList().then(data => {
            if (data.length !== 0) {// data 不为空
                // 默认选中第一个
                this.addTask.strategySelect = data[0].id;
                this.$set(this.addTaskData, 'strategySelect', data[0].id);

                if (this.taskCopyData.hasOwnProperty('taskData')) {// 任务复制时的策略 任务名称
                    var baseData = this.taskCopyData.taskData;
                    for (var i=0; i<this.strategyList.length; i++) {
                        var stra_name = this.strategyList[i].name;
                        if (stra_name == baseData.strategy_name) {
                            this.addTaskData['strategySelect'] = this.strategyList[i].id;
                            this.addTask.strategySelect = this.strategyList[i].id;
                        }
                    }
                    this.addTaskData['taskName'] = baseData.name;
                }
                
                // 获取策略参数
                this.getStrategyParam().then(data => {
                    // 策略参数处理
                    this.doStrategyParam(data);
                    this.strategyParam = data;
                    this.copyData();
                });
            }
        });
    },
    mounted() {
        
    },
    computed: {
        ...mapState([
            'bourseList',
            'addTask',
            'strategyList',
            'currencyList',
            'abourseType',
            'bbourseType',
            'token',
            'dialogVisible',
            'currencyNum',
            'tradeTypeObj',
            'currencyNumList',
            'taskCopyData'
        ]),

        // 复制策略参数处理
        handleStrategyParam: function () {
            if (this.strategyParam.strategyParams) {
                this.copyJudge();
                var new_param = deepClone(this.strategyParam.strategyParams)

                delete new_param['dlt'];
                delete new_param['m'];

                var param = {
                    'mDlt': {'dlt': this.strategyParam.strategyParams['dlt'], 'm': this.strategyParam.strategyParams['m']},
                    'other':  new_param
                };
                return param
            }
        },
        
    },
    methods: {
        ...mapActions([
            'getBourseList',
            'getaBourseType',
            'getbBourseType',
            'getStrategyList',
            // 'getCurrency',
            'getStrategyParam',
            'getTaskList',
            'getCurrencyNum'
        ]),

        // 交易所选择事件
        bourseChange(bourseName) {
            if (bourseName == 'a') {
                this.addTask.a_bourse = this.addTaskData.a_bourse;
                this.getaBourseType();
            } else {
                this.addTask.b_bourse = this.addTaskData.b_bourse;
                this.getbBourseType();
            }
        },

        // 策略参数循环遍历
        doStrategyParam(data) {
            // 清除策略参数值
            for (var i in this.addTaskData) {
                if (i !== 'strategySelect' && i !== 'taskName') {
                    delete this.addTaskData[i];
                }
            }

            if (JSON.stringify(data.debitCreditParams) !== '{}') {
                // 循环赋值
                for (var i in data.debitCreditParams) {
                    this.$set(this.addTaskData, i, data.debitCreditParams[i]);
                }
            }
            if (JSON.stringify(data.strategyParams) !== '{}') {
                // 循环 给策略参数 赋值
                for (var i in data.strategyParams) {
                    this.$set(this.addTaskData, i, '');
                }
            }
        },

        // 策略选择事件
        strategyChange() {
            this.addTask.strategySelect = this.addTaskData.strategySelect;
            this.getStrategyParam().then(data => {
                this.doStrategyParam(data);
                this.strategyParam = data;
            });
        },

        // 交易类型选择事件
        aTransTypeChange(index) {
            this.addTask[index] = this.addTaskData[index];
            this.getCurrency();
            this.copyJudge();
        },

        // 获取币种
        getCurrency() {
            var url = this.$baseUrl + '/currencyType/get';
            var aBourseType = this.addTaskData.a_transaction_type;
            var param = {
                'token': this.token,
                'aTransactionType': this.changeBourseTpye(aBourseType),
                'bTransactionType': this.changeBourseTpye(this.addTaskData.b_transaction_type)
            };

            var strategy_len = Object.keys(this.strategyParam.taskBaseParams);
            if (strategy_len.length !== 0) {// strategyParam 有值
                if (!this.strategyParam.taskBaseParams.hasOwnProperty('a_transaction_type')) {// 如果 strategyParam 没有 key=a_transaction_type
                delete param['aTransactionType'];
                }
                if (!this.strategyParam.taskBaseParams.hasOwnProperty('b_transaction_type')) {// 如果 strategyParam 没有 key=b_transaction_type
                delete param['bTransactionType'];
                }
            }

            get(url, param).then(resp => {
                if (resp.code === 200) {
                this.$store.commit('initCurrencyList', resp.data);
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },

        // 将数字字符串转换为对应的数字 eg: '191102'-> 1
        changeBourseTpye(param) {
            // param = 1 or '122345'
            var mock_data = this.addTaskData;
            if (String(param).length > 2) {
                // > 1, 表示新的值，需要转换
                for (var key in this.currencyNum) {
                    if (this.currencyNum[key] == param){// 相等, 明确需要转换的 key
                        var type_name = this.tradeTypeObj[key]; // 获取对应 key 的中文名字
                        // 根据中文名字获取 对应的数字
                        if (Number(mock_data.a_bourse) == 1) {// 交易所为 okex
                            var data1 = this.okexBourseTransaction1[type_name]; 
                            return String(data1);
                        } else {// 交易所为 huobi
                            return this.huobiBourseTransaction1[type_name];
                        }
                    } 
                }
            } else {
                return param;
            }
        },

        // 添加任务
        submitParam() {
            var url = this.$baseUrl + '/task/add';
            var paramObj = {};
            for (var i in this.addTaskData) {
                if (i !== 'taskName' && i !== 'strategySelect') {
                    if (i == 'is_borrow') {// 为 复选框
                        if (this.addTaskData[i] == 0) {
                            // false
                            paramObj[i] = false;
                        } else {
                            // true
                            paramObj[i] = true;
                        }
                    } else if (i == 'price_limit') {
                        if (this.addTaskData['price_limit'] == '' ) {
                            // 为空
                            paramObj['price_limit'] = 'no';
                        } else {
                            paramObj[i] = this.addTaskData[i];
                        }
                    } else {
                        paramObj[i] = Number(this.addTaskData[i]);
                    }
                }
            }

            // 提交任务时给 交易类型赋予新的值
            if (paramObj.hasOwnProperty('a_transaction_type')) {
                var bourse_type = this.judgeTradeType(paramObj['a_transaction_type']);
                paramObj['a_transaction_type'] = bourse_type;
            }
            if (paramObj.hasOwnProperty('b_transaction_type')) {
                var bourse_type = this.judgeTradeType(paramObj['b_transaction_type']);
                paramObj['b_transaction_type'] = bourse_type;
            }
            if (typeof this.currencyNumList !== 'undefined') {
                if (this.currencyNumList.includes(String(paramObj['b_transaction_type'])) || this.currencyNumList.includes(String(paramObj['a_transaction_type']))) {
                    // 判断 dlt m 是否 为 {}
                    var strategy_clone_param = {
                        'dlt': this.strategyParam.strategyParams['dlt'],
                        'm': this.strategyParam.strategyParams['m']
                    }
                    var strategy_name = this.getStrategyName(this.addTaskData.strategySelect);
                    // 如果两个交易所交易类型有一个是 本周、次周、季度
                    for (var key in strategy_clone_param) {
                        // 每个策略参数生成一个对象，用于存放 本周、次周、季度三个参数
                        if (strategy_name.includes('套利2')) {// 当策略名字以套利2开头， 才3分段
                            var this_strategy_param = {};
                            if (typeof this.newStrategyParam !== 'undefined') {
                                this_strategy_param['CQ'] = this.newStrategyParam['CQ'][key];
                                this_strategy_param['CW'] = this.newStrategyParam['CW'][key];
                                this_strategy_param['NW'] = this.newStrategyParam['NW'][key];
                                this_strategy_param['NQ'] = this.newStrategyParam['NQ'][key];
                            }
                            paramObj[key] = JSON.stringify(this_strategy_param);
                        }
                    }
                }
            }

            // return;
            if (this.radio == 1) {
                // 输入的资金可占用比为 百分比
                paramObj['fund_occupy'] = this.addTaskData.fund_occupy + '%'
            } else if (this.radio == 0) {
                // 输入的资金可占用比为 金额
                paramObj['fund_occupy'] = String(this.addTaskData.fund_occupy)
            }

            for (var i in this.strategyParam.taskBaseParams) {
                if (!paramObj.hasOwnProperty(i)) {
                    // 如果 paramObj 没有该字段 则 无法提交
                    this.$notify.error({
                        message: '参数不完整',
                        titlee: '提示',
                        offset: 100
                    })
                    return;
                } else {
                    this.ErrorVisible = false;
                }
            }

            var param = {
                'token': this.token,
                'name': this.addTaskData.taskName,
                'strategyId': this.addTaskData.strategySelect,
                'params': paramObj
            }
            post(url, JSON.stringify(param)).then(resp => {
                if (resp.code == 200) {
                    this.$notify.info({
                        message: '添加任务成功',
                        title: '提示',
                        offset: 100
                    });
                    // 刷新任务列表
                    setTimeout(() => {
                        this.getTaskList();
                    }, 600)
                    // 关闭窗口
                    this.dialogVisible.visible = false;
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },

        // 判断交易类型, 给交易类型赋值
        judgeTradeType(param) {
            var data = Number(param);
            if (data == 2 || data == 7) {
                // 本周
                return this.currencyNum['CW'];
            } else if (data == 3 || data == 8) {
                // 次周
                return this.currencyNum['NW'];
            } else if (data == 4 || data == 9) {
                // 季度
                return this.currencyNum['CQ'];
            } else if (data == 10) {// 次季
                return this.currencyNum['NQ'];
            } else {
                return param;
            }
        },

        // 参数名字判别
        paramJugde(index) {
            if (index == 'a_bourse') return 'A交易所';
            else if (index == 'b_bourse') return 'B交易所';
            else if (index == 'a_transaction_type') return 'A交易类型';
            else if (index == 'b_transaction_type') return 'B交易类型';
            // else if ( index == 'currency_type') return '';
            // return index;
        },

        // 借贷参数名判断
        debitCreditName(name) {
            if (name == 'fund_occupy') return '资金可占用比';
            else if (name == 'is_borrow') return '是否允许可借贷';
            else if (name == 'virtual_initial_capital') return '任务虚拟初始资金';
            else if (name == 'depth') return '价格深度';
            else if (name == 'slip') return '滑点';
            else if (name == 'price_limit') return '价格控制';
            return name;
        },

        // 交易类型名称拼接
        addBourseStr(name) {
            if (name == '本周') return this.currencyNum['CW'] + '-' +name;
            else if (name == '次周') return this.currencyNum['NW'] + '-' +name;
            else if (name == '季度') return this.currencyNum['CQ'] + '-' +name;
            else if (name == '次季') return this.currencyNum['NQ'] + '-' +name;
            return name;
        },

        addBourseValue(name, index) {
            return index;
        },

        // 任务基础参数处理
        taskBaseParamJudge(data) {
            if (data) {
                delete data['currency_type'];
                return data;
            }
        },

        // 任务复制 赋值
        copyData() {
            if (this.taskCopyData.hasOwnProperty('taskData')) {
                var baseData = this.taskCopyData.taskData;
                for (var i=0; i<this.strategyList.length; i++) {
                    var stra_name = this.strategyList[i].name;
                    if (stra_name == baseData.strategy_name) {
                        this.addTaskData['strategySelect'] = this.strategyList[i].id;
                        this.addTask.strategySelect = this.addTaskData.strategySelect;
                    }
                }
                this.addTaskData['taskName'] = baseData.name;

                var otherParam = this.taskCopyData['baseData'];
                for (var i in otherParam.taskBaseParams) {// 基础信息
                    this.addTaskData[i] = String(otherParam.taskBaseParams[i])
                }

                for (var i in otherParam.debitCreditParams) {// 借贷
                    this.addTaskData[i] = otherParam.debitCreditParams[i]
                }

                for (var i in otherParam.strategyParams) {// 策略
                    // i 为 dlt 和 m 时，单独 一特定结构赋值
                    if (i == 'dlt') {
                        let parse_dlt = JSON.parse(otherParam.strategyParams[i]);
                        for (var type in parse_dlt) {
                            this.newStrategyParam[type]['dlt'] = parse_dlt[type];
                        }
                    } else if (i == 'm') {
                        let parse_m = JSON.parse(otherParam.strategyParams[i]);
                        for (var type in parse_m) {
                            this.newStrategyParam[type]['m'] = parse_m[type];
                        }
                    } else {
                        this.addTaskData[i] = otherParam.strategyParams[i];
                    }
                }

                this.addTask.a_bourse = this.addTaskData.a_bourse;
                this.addTask.b_bourse = this.addTaskData.b_bourse;
                this.getaBourseType();
                this.getbBourseType();
                
                this.addTask.a_transaction_type = this.addTaskData.a_transaction_type;
                this.addTask.b_transaction_type = this.addTaskData.b_transaction_type;
                this.getCurrency();

                this.addTask.strategySelect = this.addTaskData.strategySelect;
            }
        },

        // test
        copyJudge() {
            if (this.strategyParam.strategyParams) {
                if (typeof this.strategyParam.strategyParams['dlt'] == 'object') {
                    this.showFlag = true
                };
            }
            let strategy_name = this.getStrategyName(this.addTaskData.strategySelect);
            if (strategy_name.includes('套利2')){// 当策略名字以套利2开头， 才3分段
                if (this.addTaskData.hasOwnProperty('a_transaction_type') || this.addTaskData.hasOwnProperty('b_transaction_type')) {
                    var a_transaction_type = Number(this.addTaskData['a_transaction_type']);
                    var b_transaction_type = Number(this.addTaskData['b_transaction_type']);
                    if (this.transactionTypeList.indexOf(a_transaction_type) !== -1 || this.transactionTypeList.indexOf(b_transaction_type) !== -1) {
                        this.showFlag = true
                    } else {
                        this.showFlag = false
                    }
                }
            } else {
                this.showFlag = false
            }
        },

        // 获取 策略参数
        getStrategyName(strategyId) {
            for (let i in this.strategyList) {
                let stategy = this.strategyList[i];
                if (strategyId == Number(stategy.id)) {
                    // id 相等
                    return stategy.name;
                }
            }
        }
    }
}
</script>

<style lang="scss">
    .add-task-dialog{
        .add-task-title{
            // background-color: #000;
            padding: 15px 15px 5px 15px;
            h3{
                text-align: center !important;
                font-size: 23px;
            }
        }
        .el-divider{
            margin: 10px 0;
        }
        .el-form{
            width: 75%;
            margin: 0 auto;
            padding: 10px 20px;
            .task-error-msg{
                color: #ea1a1a;
            }
            .strategy-param{
                display: flex;
                justify-content: flex-start;
                div{
                    .el-form-item{
                        .el-form-item__label{
                            width: 50px !important;
                        }
                        .el-form-item__content{
                            margin-left: 50px !important;
                        }
                    }
                }
            }
            .el-form-item{
                .task-name-add{
                    border: 1px solid #DCDFE6;
                    padding: 0 15px;
                    width: 100%;
                    border-radius: 4px;
                    -webkit-appearance: none;
                    display: inline-block;
                    outline: none;
                    box-sizing: border-box;
                    color: #606266;
                    height: 32px;
                    line-height: 32px;
                }
                .el-select{
                    display: flex;
                }
                .el-form-item__content{
                    text-align: left;
                    .el-input__inner{
                        // width: 60%;
                        // min-width: 225px;
                        font-size: 13px;
                    }
                    .assets-select{
                        padding: 4px 5px;
                        border-color: #DCDFE6;
                        font-size: 12px;
                        border-radius: 3px;
                    }
                }
            }
        }
        .add-task-footer1{
            padding: 0 10px 15px 10px;
            text-align: right;
            .el-button{
                padding: 10px 20px !important;
                background-color: #fff;
            }
        }
    }

    // @media screen
</style>
